import InfoIcon from "@mui/icons-material/Info";
import { Box, IconButton, Tooltip } from "@mui/material";
import { IntermediatePlateInfoState } from "features/WorklistTools/ExternalThaw/state";
import { NumberField } from "features/WorklistTools/shared/components/NumberField";

interface PelletResuspensionVolumeProps {
  item: IntermediatePlateInfoState;
  index: number;
  handleIntPlateInfoChanged: (index: number, key: string, value: any) => void;
  width: number;
}

const prvRangeError = (resuspensionVol: number) => {
  if (resuspensionVol < 200 || resuspensionVol > 2000) {
    return true;
  }
  return false;
};

export const PelletResuspensionVolume = ({
  item,
  index,
  handleIntPlateInfoChanged,
  width,
}: PelletResuspensionVolumeProps) => {
  return (
    <NumberField
      style={{ width: `${width}%`, marginTop: "10px" }}
      size="small"
      id="resuspension-vol"
      label={
        <Box sx={{ display: "inline-flex", alignItems: "center" }}>
          Pellet Resuspension Vol (µL)
          <Tooltip
            arrow
            placement="top"
            title="Total volume in each intermediate well before dead total aliquot(s) and destination seeding."
          >
            <IconButton size="small">
              <InfoIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      }
      value={item.resuspensionVol}
      onChange={(value) =>
        handleIntPlateInfoChanged(index, "resuspensionVol", parseInt(value))
      }
      hasError={prvRangeError(item.resuspensionVol)}
      errorMessage="PRV must be between 200µL and 2000µL"
    />
  );
};
